import LoadingSpinner from '@/common/components/LoadingSpinner';

export default function LoadingOverlay() {
  return (
    <div className="fixed inset-0 bg-background/50 backdrop-blur-sm flex items-center justify-center z-50">
      <LoadingSpinner className="relative" size="lg" />
    </div>
  );
}
